import { Row, Input, Col, Switch } from "antd";
import * as React from "react";
import { useContext, useState } from "react";
import { useEffect } from "src/ReactTS";
import { PendencyStatusEnum } from 'src/services/Enum/pendency/PendencyStatusEnum';
import { ITradePendency } from 'src/services/interfaces/pendency/ITradePendency';
import { formatDate, formatDateTime } from 'src/util/Date.helper';
import PbrDocUploader from "src/components/common/PbrDocUploaderTradeId/PbrDocUploader";
import { ServiceContext } from "src/services/provider/Service.provider";
import { ShowNotification } from "../../ShowNotification/ShowNotification";

export function ViewPendencyInput(props: { pendency: ITradePendency }) {
  const [tradePendency, setTradePendency] = useState<ITradePendency>(null);
  const { pendencyService } = useContext(ServiceContext);
  const [pendencyWasClosed, setPendencyWasClosed] = useState<boolean>(false);
  const { TextArea } = Input;

  useEffect(() => {
    if (props.pendency) {
      setTradePendency(props.pendency);
      setPendencyWasClosed(PendencyStatusEnum[props.pendency.status] === PendencyStatusEnum.Closed);
    }
  }, []);

  function isClosed() {
    return PendencyStatusEnum[tradePendency.status] === PendencyStatusEnum.Closed;
  }

  function handleUploadSolution(fileName: string, file: string) {
    pendencyService.uploadPendencySolutionFile(tradePendency.id, { fileName, file }).then(resp => {
      ShowNotification.Success("Enviado com sucesso", "O arquivo foi enviado com sucesso, em breve notificaremos a solução!");
    }).catch(error => {
      ShowNotification.Error("Não foi possível enviar o arquivo", "Não foi possível enviar o arquivo, tente novamente ou entre em contato");
    })
  }

  return (
    tradePendency && (
      <Row className="input-group">
        <Col span={isClosed() ? 8 : 11}>
          <span>Observação</span>
          <TextArea disabled={true} className="input" onChange={e => setTradePendency({ ...tradePendency, description: e.target.value })} value={tradePendency.description} />
        </Col>
        <Col span={pendencyWasClosed ? 4 : 5}>
          <span><b>Categoria</b></span>
          <p>{props.pendency.categoryDescription}</p>
        </Col>
        <Col span={isClosed() ? 4 : 3}>
          <p><b>Data de Criação:</b><br />{formatDate(props.pendency.creationDate)}</p>
          {pendencyWasClosed && (<p><b>Data de Fechamento:</b><br /> {formatDateTime(props.pendency.closedDate)}</p>)}
        </Col>
        <Col span={isClosed() ? 2 : 3}>
          <p><b>Data de Envio da Pendência:</b><br />{formatDate(props.pendency.uploadedFileDate)}</p>
        </Col>
        {isClosed() && (
          <Col span={7}>
            <span>Justificativa do fechamento</span>
            <TextArea disabled={true} className="input" onChange={e => setTradePendency({ ...tradePendency, justification: e.target.value ?? null })} value={tradePendency.justification} />
          </Col>

        )}

        {!isClosed() && (
          <Col span={3}>
            <span>Enviar arquivo</span>
            <PbrDocUploader
              onChangeBase64={val => handleUploadSolution(val.name, val.file)}
            />
          </Col>
        )}

        {
          <Col span={3}>
            <Switch
              disabled={true}
              checkedChildren={"Fechado"}
              unCheckedChildren="Aberto"
              checked={isClosed()}
              onChange={e => {
                if (!pendencyWasClosed) {
                  setTradePendency({ ...tradePendency, status: e ? PendencyStatusEnum[PendencyStatusEnum.Closed] : PendencyStatusEnum[PendencyStatusEnum.Opened], justification: null });
                }
              }}
            />
          </Col>
        }
      </Row>
    )
  );
}



// WEBPACK FOOTER //
// ./src/components/common/Pendency/ViewPendency/ViewPendencyInput.tsx